<template>
  <!-- <ion-page> -->

    <ion-content>
      <section class="block__center" style="margin-top:100px;">
        <h1 class="text-center font-bold ">TEST APIS</h1>
          <b-row>
              <b-col sm="12" lg='6'>
                  <PuSkeleton 
                  :loading='this.loading'
                   :count="5">
                   <div><pre style="white-space: pre">{{test}}</pre></div>
                    </PuSkeleton>

                    <!-- <ion-skeleton-text v-if="this.loading === true" animated style="width: 100%; height:69px;"></ion-skeleton-text>
                    <ion-textarea v-if="this.loading === false" readonly="true" v-bind:value="this.test">
                    </ion-textarea>                   -->
              </b-col>


              <b-col sm="12" lg='6'>


                    <br />

                    <h1 class="text-center font-bold ">Test API Ping</h1>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGet()" class="bt bt-border select w-1/3">GET</ion-button>
                    </div>

                    <h1 class="text-center font-bold ">Test API User</h1>
                    <div class="flex mb-4 w-full">
                    <ion-button v-on:click="trySecureGet()" class="bt bt-border select w-1/3">SECURE GET</ion-button>
                    <ion-button v-on:click="tryPatch()" class="bt bt-border select w-1/3">PATCH</ion-button>
                    <ion-button v-on:click="tryGetFavorites()" class="bt bt-border select w-1/3">GET FAVORITES</ion-button>
                    <ion-button v-on:click="tryGetResume()" class="bt bt-border select w-1/3">GET RESUME</ion-button>
                    </div>

                    <h1 class="text-center font-bold ">Test API Concours</h1>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetConcours()" class="bt bt-border select w-1/3">GET</ion-button>
                        <ion-button v-on:click="tryGetConcoursHome()" class="bt bt-border select w-1/3">GET Home</ion-button>
                        <ion-button v-on:click="tryGetConcoursResult()" class="bt bt-border select w-1/3">GET result</ion-button>
                        <ion-button v-on:click="tryGetConcoursResultClassement()" class="bt bt-border select w-1/3">GET classement</ion-button>
                        <ion-button v-on:click="tryGetConcoursResume()" class="bt bt-border select w-1/3">GET resume</ion-button>
                    </div>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetDestination()" class="bt bt-border select w-1/3">GET destination</ion-button>
                        <ion-button v-on:click="tryGetExcursionList()" class="bt bt-border select w-1/3">GET liste excursions</ion-button>
                        <ion-button v-on:click="tryGetExcursionData()" class="bt bt-border select w-1/3">GET excursion data</ion-button>
                        <ion-button v-on:click="tryGetExcursionRanking()" class="bt bt-border select w-1/3">GET excursion classement</ion-button>
                    </div>

                    <h1 class="text-center font-bold ">Test API Suivi des objectifs</h1>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetCLassificationPlan()" class="bt bt-border select w-1/3">GET classification plan</ion-button>
                        <ion-button v-on:click="tryGetCriterion()" class="bt bt-border select w-1/3">GET criterion</ion-button>
                        <ion-button v-on:click="tryGetCriteriaDetail()" class="bt bt-border select w-1/3">GET critere detail</ion-button>
                        <ion-button v-on:click="tryGetCriteriaRanking()" class="bt bt-border select w-1/3">GET critere classement</ion-button>
                    </div>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetCommercial()" class="bt bt-border select w-1/3">GET Commerciaux</ion-button>
                        <ion-button v-on:click="tryGetFollowCommercial()" class="bt bt-border select w-1/3">GET Commerciaux suivi</ion-button>
                    </div>

                    <h1 class="text-center font-bold ">Test API Shop</h1>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetShop()" class="bt bt-border select w-1/3">GET</ion-button>
                    </div>

                    <h1 class="text-center font-bold ">Test API Challenge</h1>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetChallenges()" class="bt bt-border select w-1/3">GET</ion-button>
                        <ion-button v-on:click="tryAddChallenge()" class="bt bt-border select w-1/3">POST</ion-button>
                        <ion-button v-on:click="tryEditChallenge()" class="bt bt-border select w-1/3">PATCH</ion-button>
                        <ion-button v-on:click="tryDeleteChallenge()" class="bt bt-border select w-1/3">DELETE</ion-button>
                    </div>
                    <div class="flex mb-4 w-full">
                        <ion-button v-on:click="tryGetCategories()" class="bt bt-border select w-1/3">GET categories</ion-button>
                        <ion-button v-on:click="tryGetCriterionList()" class="bt bt-border select w-1/3">GET criteres</ion-button>
                    </div>

            </b-col>
          </b-row>
      </section>
    </ion-content>

  <!-- </ion-page> -->
</template>


<script>
import ApiService from "../../services/ApiService";
import ApiAuthenticationService from "../../services/ApiAuthenticationService";
import ClassificationPlanUtils from "../../services/utils/ClassificationPlanUtils";

let currentUser = ApiAuthenticationService.getCurrentUser();
console.log(currentUser);

export default {
  data () {
    return {
      loading : false,
      test: null,
    }
  },
  methods : {
    tryGet() {
      this.loading = true;

      ApiService.getPingApi().ping().then(response => {
        this.test = JSON.stringify(response.data);
      })
      .catch(error => {
        this.test = JSON.stringify(error);
      })
      .finally(() => this.loading = false)
    },
    trySecureGet() {
      this.loading = true;

      ApiService.getProfilApi().get().then(response => {
        this.test = JSON.stringify(response.data);
      })
      .catch(error => {
        this.test = JSON.stringify(error.response.data);
      })
      .finally(() => this.loading = false);
    },
    tryPatch() {

      if(currentUser){
        this.loading = true;

        ApiService.getProfilApi().patch(currentUser.id,{
          lastName: "CATINOT",
          name: "Benjamin"
        }).then(response => {
          this.test = JSON.stringify(response.data);
        })
        .catch(error => {
          this.test = JSON.stringify(error.response.data);
        })
        .finally(() => this.loading = false);
      }
    },
    tryGetFavorites() {
      let currentUser = ApiAuthenticationService.getCurrentUser();
      console.log("tryGetFavorites -> currentUser", currentUser)

      if(currentUser) {
        this.loading = true;

        ApiService.getProfilApi().getFavorites(currentUser.id).then(response => {
          this.test = JSON.stringify(response.data);
        })
        .catch(error => {
            this.test = JSON.stringify(error.response.data);
        })
        .finally(() => this.loading = false);
      }
    },
    tryGetResume() {
      let currentUser = ApiAuthenticationService.getCurrentUser();

      if(currentUser) {
        this.loading = true;

        ApiService.getProfilApi().getResume(currentUser.id).then(response => {
          this.test = JSON.stringify(response.data);
        })
                .catch(error => {
                  this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
      }
    },
    tryGetConcours() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;

            ApiService.getConcoursApi().get().then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetDestination() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getDestination(concoursId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetConcoursHome() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getHome(currentUser.id, concoursId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetConcoursResume() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getResume(currentUser.id, concoursId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetConcoursResult() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getResult(currentUser.id, concoursId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetConcoursResultClassement() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getClassement(currentUser.id, concoursId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetExcursionList() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getExcursionList(concoursId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetExcursionData() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            let excursionId = 'b4f55183-b0ab-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getExcursionData(concoursId, excursionId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetExcursionRanking() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let concoursId = 'b449aeb5-b0a9-11ea-b9a7-000c29927eea';
            let excursionId = 'b4f55183-b0ab-11ea-b9a7-000c29927eea';
            ApiService.getConcoursApi().getExcursionRanking(currentUser.id, concoursId, excursionId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCLassificationPlan() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            ApiService.getObjectifMonitoringApi().getClassificationPlan().then(response => {
                //let prefix = "commercial";
                let prefix = "parcourir";
                this.test = JSON.stringify(ClassificationPlanUtils.format(response.data, '/admin/' + currentUser.id + "/" + prefix + "/"));
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCriterion() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let categoryId = '38d74c25-b6fd-11ea-b9a7-000c29927eea';
            ApiService.getObjectifMonitoringApi().getCriterion(currentUser.id, categoryId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCriteriaDetail() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let categoryId = '38d74c25-b6fd-11ea-b9a7-000c29927eea';
            let criteria = '0';
            let period = 'semaine';
            ApiService.getObjectifMonitoringApi().getCriteriaDetail(currentUser.id, categoryId, criteria, period).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCriteriaRanking() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let categoryId = '38d74c25-b6fd-11ea-b9a7-000c29927eea';
            let criteria = '0';
            let period = 'semaine';
            let type = 'inspecteurs';
            ApiService.getObjectifMonitoringApi().getCriteriaRanking(currentUser.id, categoryId, criteria, period, type).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCommercial() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            ApiService.getObjectifMonitoringApi().getCommercialList(currentUser.id, 20, '', 0, null).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetFollowCommercial() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            ApiService.getObjectifMonitoringApi().getFollowCommercialList(currentUser.id).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetShop() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            ApiService.getShopApi().get(currentUser.id).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetChallenges() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            ApiService.getChallengeApi().get(currentUser.id, 2, 0).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryAddChallenge() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let challengeData = {
                title: "TEST AJOUT",
                reference: ""
            };
            ApiService.getChallengeApi().post(currentUser.id, challengeData).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryEditChallenge() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let challengeData = {
                title: "TEST modif",
                reference: ""
            };
            let challengeId = '';
            ApiService.getChallengeApi().patch(currentUser.id, challengeId, challengeData).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryDeleteChallenge() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let challengeId = '';
            ApiService.getChallengeApi().delete(currentUser.id, challengeId).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCategories() {
        let currentUser = ApiAuthenticationService.getCurrentUser();

        if(currentUser) {
            this.loading = true;
            let reference = 'TYPE_VIE';
            //let reference = 'TYPE_QUALITE';
            //let reference = 'TYPE_DOMMAGES';
            ApiService.getChallengeApi().getCategoriesList(reference).then(response => {
                this.test = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.test = JSON.stringify(error.response.data);
                })
                .finally(() => this.loading = false);
        }
    },
    tryGetCriterionList() {
          let currentUser = ApiAuthenticationService.getCurrentUser();

          if(currentUser) {
              this.loading = true;
              let categoryId = '468c9dc2-b6fa-11ea-b9a7-000c29927eea';
              ApiService.getChallengeApi().getCriterionList(categoryId).then(response => {
                  this.test = JSON.stringify(response.data);
              })
                  .catch(error => {
                      this.test = JSON.stringify(error.response.data);
                  })
                  .finally(() => this.loading = false);
          }
      }
  },
  mounted () {
    this.loading = true;

    ApiService.getPingApi().ping().then(response => {
         this.test = JSON.stringify(response.data);
    })
    .catch(error => {
         this.test = JSON.stringify(error);
    })
    .finally(() => this.loading = false)
  }
};
</script>
